import React from 'react';
import BiCalculator from './CalculatorIcon';
import leftpane from "./leftpane.jpg";

export default function LeftPane() {
  return (
    <div className="draught-wastage" style={{ background: `url(${leftpane}) no-repeat center center / cover` }}>
    </div>
  );
}
